import styled from 'styled-components'
import media from 'styled-media-query'

export const Search = {
  Wrap: styled.div`
    display: flex;
  `,

  Field: styled.div`
    flex: 1;
  `,

  Action: styled.div`
    padding-top: 22px;
    margin-left: 8px;

    flex: 0.4;

    > button {
      width: 100%;
    }

    ${media.greaterThan('huge')`
      margin-left: 16px;
      padding-top: 25px;
    `}
  `,
}
